export const TARA_MODULE_LABELS = {
  critical_thinking: 'Critical Thinking',
  problem_solving: 'Problem Solving',
  writing: 'Writing Task',
};

export const TARA_MODULE_KEYS = ['critical_thinking', 'problem_solving', 'writing'];

export function taraModuleLabel(moduleKey) {
  return TARA_MODULE_LABELS[moduleKey] || moduleKey || '';
}
